<template>
  <div class="text-right">

    <b-overlay class="overlay-image"
               id="loading"
               no-center
               :show="$store.getters['Loading/loadingStatus']"
               variant="light"
               opacity="1"
               blur="2px"
               rounded="sm">

      <template #overlay>

        <m-loading-1/>
      </template>
      <m-tool-bar-1/>
      <router-view/>
    </b-overlay>

  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  mounted() {
  }
}
</script>
<style>

@import url('https://fonts.googleapis.com/css2?family=Lalezar&display=swap');

@font-face {
  font-family: iransans;
  src: url('fonts/iransanse/IRANSansWeb.eot');
  src: url('fonts/iransanse/IRANSansWeb.eot?#iefix') format('embedded-opentype'),
  url('fonts/iransanse/IRANSansWeb.woff2') format('woff2'),
  url('fonts/iransanse/IRANSansWeb.woff') format('woff'),
  url('fonts/iransanse/IRANSansWeb.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'iransans', sans-serif !important;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Lalezar', sans-serif !important;
}

:root {
  --primary: #a4ce58 !important;
  --secondary: #266809 !important;
  --light-primary: #a4ce58 !important;
  --light-secondary: #266809 !important;
  --dark: #221f1b !important;
  --light: #1c1c1c !important;
  --light-yellow: rgb(255, 255, 177) !important;
  --light-red: #a4ce58 !important;
  --light-blue: rgb(194, 194, 255) !important;
  --light-green: rgb(155, 255, 155) !important;
  --light-gray: rgb(219, 219, 219) !important;
  --light-indigo: rgb(148, 128, 163) !important;
  --light-white: black !important;
  --light-orange: rgb(255, 234, 196) !important;
  --light-teal: rgb(133, 187, 187) !important;
  --light-danger: rgb(248, 113, 113) !important;
  --light-warning: rgb(236, 225, 119) !important;
  --light-pink: rgb(248, 219, 224) !important;
  --light-cyan: #f1f2f2 !important;
  --light-success: #ffbf22 !important;
  --light-info: #fff !important;
}


.badge-primary {
  background: var(--secondary) !important;
}

.btn-secondary {
  background-color: var(--light-secondary) !important;
  border: none !important;
}

.btn-primary {
  background-color: var(--primary) !important;
  border: none !important;
  color: white !important;
}

.btn-purple {
  color: white !important;
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}

.text-left {
  text-align: left;
  direction: ltr;
}

.text-left::placeholder {
  text-align: right;
  direction: rtl;
}

.bg-primary {
  background: var(--primary) !important;
  color: var(--light) !important;
}


.swiper-button-next, .swiper-button-prev {
  color: var(--secondary) !important;
}

.swiper-pagination-bullet, .swiper-pagination-bullet-active, .swiper-pagination-bullet-active-main {
  color: var(--primary) !important;
  background: var(--secondary) !important;
}

.btn-outline-primary {
  color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary:hover {
  color: white !important;
  background: var(--primary) !important;

}

.custom-z-index {
  z-index: 1040;
}

.bg-secondary {
  background: var(--secondary) !important;
}

</style>